// extracted by mini-css-extract-plugin
export default {"Widget":"MiniWidget_Widget__mJyVk","Text":"MiniWidget_Text__qJa9I"};